export const caseStudyBannerAr = {
  mainHeading: "دراسات حالة ملهمة",
  content: "استكشف كيف ساعدنا الشركات على الابتكار والنمو والنجاح من خلال حلول تقنية مخصصة.",
  buttonText: "تواصل معنا",
  backgroundImage: "/images/portfolio-banner-bg-image.png",
};

export const caseStudiesContentAr = {
  buttonText: "تنزيل الآن (PDF)",
  indusTryHeading: "الصناعة",
  caseStudiesHeading: "دراسات الحالة",
  loadMoreButton: "تحميل المزيد",
  loadLessButton: "تحميل أقل",
  readmoreButton: "اقرأ المزيد",
  caseStudyStats: [
    {
      icon: "progress-icon.svg",
      title: "100%",
      description: "الامتثال للوائح حماية البيانات العامة (GDPR)"
    },
    {
      icon: "faster-growing.svg",
      title: "75%",
      description: "معالجة النماذج بشكل أسرع"
    }
  ],
  cardsData: [
    {
      id: 1,
      title: "تطبيق التعلم الذاتي المدعوم بالذكاء الاصطناعي",
      industry: "تقنية التعليم، حلول الذكاء الاصطناعي",
      description:
        "يقدم تطبيق التعلم الذاتي المدعوم بالذكاء الاصطناعي الذي طورته Bitsclan IT Solutions تجربة تعلم مرنة، جذابة، وشخصية. من خلال دمج رؤى الذكاء الاصطناعي، والتلعيب، وأشكال المحتوى المتنوعة، يمكّن التطبيق المستخدمين من التعلم بشكل مستقل، والبقاء متحمسين، وإتقان المواضيع في بيئة موجهة ذاتيًا. هذه الحلول لا تحسن نتائج الطلاب فقط، بل تجعل التعلم متاحًا وممتعًا لجمهور عالمي.",
      image: "ai-self-study.avif",
      pdfUrl: "AI Case Studies 7.pdf",
      tags: [
        "التعلم المدعوم بالذكاء الاصطناعي",
        "التعليم الشخصي",
        "حلول التعليم التكنولوجي",
        "التلعيب في التعلم",
        "تطبيق التعلم الذاتي",
        "منصة تعلم قابلة للتوسع",
      ],
    },
    {
      id: 2,
      title: "النشرة الإخبارية التقنية الشخصية باستخدام RSS، OpenAI، وGmail",
      industry: "أتمتة الذكاء الاصطناعي، التسويق عبر البريد الإلكتروني، التكنولوجيا",
      description:
        "النشرة الإخبارية التقنية الشخصية التي طورتها Bitsclan IT Solutions هي حل مثالي للمهنيين الذين يرغبون في البقاء على اطلاع دون عناء تصفح مئات المقالات يوميًا. من خلال أتمتة العملية بالكامل، من جلب المحتوى إلى التلخيص وتوصيل البريد الإلكتروني، أنشأنا أداة قوية توفر الوقت لعشاق التكنولوجيا. يعرض هذا سير العمل المدعوم بالذكاء الاصطناعي كيفية دفع الأتمتة للكفاءة، وتعزيز تجربة المستخدم، وتحسين تسليم المعلومات في مشهد التكنولوجيا الحديث.",
      image: "personalized-ai.avif",
      pdfUrl: "AI Case Studies 05.pdf",
      tags: [
        "الأخبار المدعومة بالذكاء الاصطناعي",
        "أتمتة أخبار التكنولوجيا",
        "النشرات الإخبارية الشخصية",
        "دمج RSS",
        "أتمتة البريد الإلكتروني",
        "حلول overload المعلومات",
      ],
    },
    {
      id: 3,
      title: "الدردشة مع النماذج المحلية باستخدام n8n وOllama",
      industry: "حلول الذكاء الاصطناعي، أتمتة سير العمل، خصوصية البيانات",
      description:
        "من خلال تكامل n8n وOllama الذي قدمته Bitsclan IT Solutions، حصلت الشركات على حل آمن وقابل للتوسع وفعال من حيث التكلفة للتفاعلات المدعومة بالذكاء الاصطناعي. من خلال الاستفادة من النماذج المحلية، يضمن النظام خصوصية البيانات القوية، والمرونة، وتوفير التكاليف، مما يجعله خيارًا مثاليًا للشركات التي ترغب في تبني وكلاء الذكاء الاصطناعي وسير العمل دون المساس بالأمان.",
      image: "chat-with-local.avif",
      pdfUrl: "AI Case Studies 02.pdf",
      tags: [
        "نماذج الذكاء الاصطناعي المحلية",
        "خصوصية البيانات",
        "أتمتة سير العمل بالذكاء الاصطناعي",
        "حلول الذكاء الاصطناعي ذات التكلفة الفعالة",
        "تفاعلات الذكاء الاصطناعي الآمنة",
        "تكامل LLM",
      ],
    },
    {
      id: 4,
      title: "تحسين منصة الشحن عبر الحدود",
      industry: "اللوجستيات والشحن",
      description:
        "من خلال Bitsclan IT Solutions، تحولت Airdropja إلى منصة قوية تقدم شحنًا مرنًا، وتنسيقًا فعالًا، وتتبعًا موثوقًا. هذه التحسينات قد عززت مكانتها كقائدة في الشحن عبر الحدود في منطقة البحر الكاريبي.",
      image: "cross-border-shipping.avif",
      pdfUrl: "Cross Border Shipping Platform.pdf",
      tags: [
        "الشحن عبر الحدود",
        "تحسين المنصة",
        "دمج بوابات الدفع",
        "مرونة الشحن",
        "حلول الأخطاء",
        "مشاركة المستخدم",
      ],
    },
    {
      id: 5,
      title: "تطبيق ويب لاختبار ومعايرة المعدات الكهربائية",
      industry: "منصة اختبار ومعايرة المعدات الكهربائية",
      description:
        "بفضل خبرة Bitsclan IT Solutions، تطورت المنصة إلى موقع ويب عالي الأداء، متكامل تمامًا، ويركز على التحويل. من خلال معالجة الفجوات في الأداء، والاستجابة، وتجربة المستخدم، يمكن للعملاء الآن توسيع العمليات بثقة، وتحسين رضا العملاء، وزيادة الإيرادات في بيئة رقمية تنافسية.",
      image: "electrical-testing.avif",
      pdfUrl: "Electrical Testing & Calibration Platform.pdf",
      tags: [
        "تحسين المواقع الإلكترونية",
        "تحسين معدل التحويل",
        "الاستجابة عبر الهاتف المحمول",
        "التكاملات",
        "تحسين الأداء",
        "تعزيز تجربة العملاء",
      ],
    },
    {
      id: 6,
      title: "تحسين التذاكر والترويج للفعاليات من أجل النمو القابل للتوسع",
      industry: "تذاكر الفعاليات والترويج",
      description:
        "مع Bitsclan IT Solutions كشريك رقمي، تعمل المنصة الآن كنظام عالي الأداء يركز على المستخدم، حيث تدمج إدارة الفعاليات والتذاكر والترويج بسلاسة. من خلال الأتمتة المتقدمة للتسويق، وأنظمة الدعم القوية، وسير العمل السلس لإنشاء الفعاليات، فإن المنصة مستعدة للتوسع بثقة، مما يمكن منظمين الفعاليات من التركيز على إنشاء تجارب لا تُنسى.",
      image: "optimizing-ticketing.avif",
      pdfUrl: "Ticketing & Events Promotion Platform.pdf",
      tags: [
        "نظام تذاكر الفعاليات",
        "أتمتة التسويق",
        "تحسين دعم العملاء",
        "قابلية الاستخدام في لوحة الإدارة",
        "ترويج الفعاليات القابل للتوسع",
        "تحسين معدل التحويل",
      ],
    },
  ],
};
